<template>
    <div v-if="remainingTime !== null" class="timer">
        {{ remainingTime }}
    </div>
</template>

<script>
export default {
    name: 'Timer',
    props: {
        expTime: {
            required: true,
            type: Number,
        },
    },
    data() {
        return {
            timer: null,
            timeLeft: null,
        };
    },
    computed: {
        remainingTime() {
            if (this.timeLeft === null) return null;
            const minutes = Math.floor(this.timeLeft / 60);
            const seconds = Math.floor(this.timeLeft % 60);
            return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        },
    },
    methods: {
        startTimer() {
            if (this.expTime === null) return;
            this.timer = setInterval(() => {
                const now = Math.floor(Date.now()); // Current time in seconds
                this.timeLeft = (this.expTime - now) / 1000; // Calculate remaining time
                if (this.timeLeft <= 0) {
                    this.timeLeft = null;
                    clearInterval(this.timer);
                    console.log("Timer expired");
                    this.$store.dispatch('getCart');
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000);
                }
            }, 1000);
        },
    },
    updated() {
        if (this.timer == null) {
            this.startTimer();
        }
    },
    created() {
        if (this.timer == null) {
            this.startTimer();
        }
    },
    beforeUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
};
</script>